export default {
  name: 'philosphy',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/views/Philosphy/Philosphy.js